module.exports = __webpack_public_path__ + "img/GAME_FLAG.1036042b.png";